import React from 'react';
import PromptForm from './components/PromptForm';
import './index.css';

function App() {
  return (
    <div className="App">
      <PromptForm />
    </div>
  );
}

export default App; 